import { ShadowlessElement } from '@blocksuite/hive/std';
import { AiIcon } from '@blocksuite/icons/lit';
import { css, html } from 'lit';

const HiveAvatarIcon = AiIcon({
  width: '20px',
  height: '20px',
  style: 'color: var(--hive-primary-color)',
});

export class AssistantAvatar extends ShadowlessElement {
  static override styles = css`
    .assistant-avatar {
      display: inline-flex;
      align-items: center;
      gap: 8px;
    }
  `;
  protected override render() {
    return html`<span class="assistant-avatar"
      >${HiveAvatarIcon} Hive AI</span
    >`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'chat-assistant-avatar': AssistantAvatar;
  }
}
